import React, { useEffect, useState } from "react";
import "../Styles/ViewEmployeeRegistration.css";
import { useNavigate } from "react-router-dom";

import {
  FaFilter,
  FaSearch,
  FaEnvelope,
  FaDownload,
  FaTrash,
  FaCommentDots,
} from "react-icons/fa";

import { IoLogoWhatsapp } from "react-icons/io";

import { saveAs } from "file-saver";
import { Document, Packer, Paragraph, TextRun } from "docx";

import Employeefilter from "../components/AdminDashboard/Employeefilter";

import ApiService from "../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

function ViewEmployeeRegistration() {
  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [page, setPage] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);

  const [sendOptions, setSendOptions] = useState({
    email: false,
    whatsapp: false,
    message: false,
  });

  const recordsPerPage = 10;

  /* =========================
     FETCH EMPLOYEES
  ========================== */
  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const res = await AdminAPI.getEmployees();

      console.log("EMPLOYEE API RESPONSE =>", res.data);

      const list =
        res.data?.data ||
        res.data?.employees ||
        res.data ||
        [];

      /*
        API FORMAT:
        {
          member: {},
          details: {}
        }
      */

      const approvedEmployees = list
        .map((item, index) => {
          const member = item.member || item;
          const details = item.details || {};

          return {
            id:
              member.membership_id ||
              member.id ||
              details.member_id ||
              index,

            membershipId:
              member.membership_id ||
              member.id,

            memberId:
              member.membership_id ||
              member.id,

            name:
              member.full_name ||
              member.name ||
              "",

            phone:
              member.mobile ||
              member.phone ||
              "",

            email:
              member.email ||
              details.official_email ||
              "",

            industry:
              details.industry ||
              "",

            state:
              member.state ||
              details.state ||
              "",

            organization:
              details.organization_name ||
              "",

            designation:
              details.designation ||
              "",

            status:
              (
                member.status ||
                ""
              ).toLowerCase(),

            image:
              member.profile_pic ||
              "",

            raw: item,
          };
        })
        .filter(
          (emp) =>
            emp.status === "approved"
        );

      setEmployees(approvedEmployees);

      console.log(
        "APPROVED EMPLOYEES =>",
        approvedEmployees
      );
    } catch (err) {
      console.error("EMPLOYEE FETCH ERROR:", err);
    }
  };

  /* =========================
     SEARCH
  ========================== */
  const filtered = employees.filter((emp) => {
    const term = searchTerm.toLowerCase();

    return (
      emp.name.toLowerCase().includes(term) ||
      emp.phone.toLowerCase().includes(term) ||
      emp.industry.toLowerCase().includes(term) ||
      emp.organization.toLowerCase().includes(term) ||
      emp.state.toLowerCase().includes(term) ||
      String(emp.memberId)
        .toLowerCase()
        .includes(term)
    );
  });

  /* =========================
     PAGINATION
  ========================== */
  const totalPages =
    Math.ceil(filtered.length / recordsPerPage) || 1;

  const paginated = filtered.slice(
    (page - 1) * recordsPerPage,
    page * recordsPerPage
  );

  /* =========================
     SELECT ALL
  ========================== */
  const toggleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(
        paginated.map((emp) => emp.id)
      );
    } else {
      setSelectedIds([]);
    }
  };

  /* =========================
     SINGLE SELECT
  ========================== */
  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  /* =========================
     DELETE
  ========================== */
  const handleDeleteSelected = () => {
    if (!selectedIds.length) return;

    setEmployees((prev) =>
      prev.filter(
        (emp) =>
          !selectedIds.includes(emp.id)
      )
    );

    setSelectedIds([]);
  };

  /* =========================
     SEND
  ========================== */
  const handleSendMessages = () => {
    if (!selectedIds.length) {
      alert("Select employees first");
      return;
    }

    const channels = [];

    if (sendOptions.email)
      channels.push("Email");

    if (sendOptions.whatsapp)
      channels.push("WhatsApp");

    if (sendOptions.message)
      channels.push("Message");

    if (!channels.length) {
      alert("Select communication method");
      return;
    }

    alert(
      `Sent via ${channels.join(", ")}`
    );
  };

  /* =========================
     DOWNLOAD
  ========================== */
  const handleDownloadSelected = async () => {
    const selectedEmployees =
      employees.filter((emp) =>
        selectedIds.includes(emp.id)
      );

    for (const emp of selectedEmployees) {
      const doc = new Document({
        sections: [
          {
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Employee Details",
                    bold: true,
                    size: 32,
                  }),
                ],
              }),

              new Paragraph(
                `Member ID: ${emp.memberId}`
              ),

              new Paragraph(
                `Name: ${emp.name}`
              ),

              new Paragraph(
                `Phone: ${emp.phone}`
              ),

              new Paragraph(
                `Email: ${emp.email}`
              ),

              new Paragraph(
                `Industry: ${emp.industry}`
              ),

              new Paragraph(
                `State: ${emp.state}`
              ),

              new Paragraph(
                `Organization: ${emp.organization}`
              ),

              new Paragraph(
                `Designation: ${emp.designation}`
              ),
            ],
          },
        ],
      });

      const blob =
        await Packer.toBlob(doc);

      saveAs(
        blob,
        `${emp.name}_details.docx`
      );
    }
  };

  return (
    <div className="empviewreg-container">

      {/* ================= HEADER ================= */}
      <div className="empviewreg-header-bar">
        <h2>
          EMPLOYEE REGISTRATION
          (APPROVED ONLY)
        </h2>

        <p>
          Total Approved:
          <b> {employees.length}</b>
        </p>
      </div>

      {/* ================= ACTION BAR ================= */}
      <div className="empview-action-bar">

        <button
          className="empview-filter-btn"
          onClick={() =>
            setOpenFilter(!openFilter)
          }
        >
          <FaFilter /> Filter
        </button>

        <div className="empview-search-box">
          <FaSearch />

          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(
                e.target.value
              )
            }
          />
        </div>

        <button
          className="empview-delete-btn"
          onClick={
            handleDeleteSelected
          }
        >
          <FaTrash /> Delete
        </button>

      </div>

      {/* ================= TOOLBAR ================= */}
      <div className="empview-toolbar">

        <label>
          {employees.length} Employee
        </label>

        {/* EMAIL */}
        <label>
          <input
            type="checkbox"
            checked={sendOptions.email}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                email: !p.email,
              }))
            }
          />

          <FaEnvelope /> Email
        </label>

        {/* WHATSAPP */}
        <label>
          <input
            type="checkbox"
            checked={
              sendOptions.whatsapp
            }
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                whatsapp:
                  !p.whatsapp,
              }))
            }
          />

          <IoLogoWhatsapp />
          WhatsApp
        </label>

        {/* MESSAGE */}
        <label>
          <input
            type="checkbox"
            checked={
              sendOptions.message
            }
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                message:
                  !p.message,
              }))
            }
          />

          <FaCommentDots />
          Message
        </label>

        {/* DOWNLOAD */}
        <button
          className="empview-download-btn"
          onClick={
            handleDownloadSelected
          }
        >
          <FaDownload />
          Download
        </button>

        {/* SEND */}
        <button
          className="empview-send-btn"
          onClick={
            handleSendMessages
          }
        >
          Send
        </button>

      </div>

      {/* ================= TABLE ================= */}
      <div className="empview-table-container">

        <table className="empview-table table table-hover">

          <thead>
            <tr>

              <th>
                <input
                  type="checkbox"
                  onChange={
                    toggleSelectAll
                  }
                  checked={
                    paginated.length >
                      0 &&
                    paginated.every(
                      (emp) =>
                        selectedIds.includes(
                          emp.id
                        )
                    )
                  }
                />
              </th>

              <th>Member ID</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Industry</th>
              <th>State</th>
              <th>Organization</th>
              <th>Action</th>

            </tr>
          </thead>

          <tbody>

            {paginated.length > 0 ? (
              paginated.map((emp) => (
                <tr key={emp.id}>

                  {/* CHECKBOX */}
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(
                        emp.id
                      )}
                      onChange={() =>
                        toggleSelect(
                          emp.id
                        )
                      }
                    />
                  </td>

                  {/* MEMBER ID */}
                  <td>
                    {emp.memberId}
                  </td>

                  {/* NAME */}
                  <td>{emp.name}</td>

                  {/* PHONE */}
                  <td>{emp.phone}</td>

                  {/* INDUSTRY */}
                  <td>
                    {emp.industry}
                  </td>

                  {/* STATE */}
                  <td>{emp.state}</td>

                  {/* ORGANIZATION */}
                  <td>
                    {emp.organization}
                  </td>

                  {/* ACTION */}
                  <td>
                    <button
                      className="empview-view-btn"
                      onClick={() =>
                        navigate(
                          "/dashboard/EmpregView",
                          {
                            state: {
                              membershipId:
                                emp.membershipId,
                            },
                          }
                        )
                      }
                    >
                      View
                    </button>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="8"
                  className="empview-no-data"
                >
                  No approved employees found
                </td>
              </tr>
            )}

          </tbody>

        </table>

      </div>

      {/* ================= PAGINATION ================= */}
      <div className="empview-pagination">

        <button
          onClick={() =>
            setPage(page - 1)
          }
          disabled={page === 1}
        >
          Previous
        </button>

        <span>
          Page {page} of{" "}
          {totalPages}
        </span>

        <button
          onClick={() =>
            setPage(page + 1)
          }
          disabled={
            page === totalPages
          }
        >
          Next
        </button>

      </div>

      {/* ================= FILTER ================= */}
      {openFilter && (
        <Employeefilter />
      )}

    </div>
  );
}

export default ViewEmployeeRegistration;